module.exports = __webpack_public_path__ + "static/media/nrl-fantasy-draft-logo-header.f714d0b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nrl-fantasy-draft-logo-header.svg
// module id = 1176
// module chunks = 0